import React from 'react';
import { Card } from './ui/card';
import { CheckCircle } from 'lucide-react';

const IncludedServices = () => {
  const services = [
    { id: 'arbeitslohn', text: 'Arbeitslohn' },
    { id: 'anfahrt', text: 'An- und Abfahrt' },
    { id: 'abdeckarbeiten', text: 'Abdeckarbeiten' },
    { id: 'abkleben', text: 'Abkleben von Fenstern, Türen und Steckdosen' },
    { id: 'bohrloecher', text: 'Schließen von Bohrlöchern und kleinen Rissen' },
    { id: 'anstrich', text: 'Hochdeckender Weißanstrich von Wänden und Decken' },
    { id: 'werkzeug', text: 'Professionelles Malerwerkzeug' },
    { id: 'sauber', text: 'Saubere Ausführung' },
    { id: 'bezahlung', text: 'Bezahlung nach Fertigstellung' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Was ist inklusive
            </h2>
            <p className="text-xl text-slate-600">
              Unser Komplettservice für Ihre Wohnung
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {services.map((service) => (
              <Card
                key={service.id}
                className="p-5 bg-white hover:shadow-lg transition-all duration-300 border-2 hover:border-blue-200"
              >
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-lg text-slate-700">{service.text}</span>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IncludedServices;